import React, { useState, useRef } from 'react';
import RequestInfoModal from '../../../common/requestInfoModal';
import DoctorMinistryAccordion from './doctorMinistryAccordion';

function DoctorOfMinistry(props) {
	const elementRef = useRef([]);
	const islamic_doctor_data = props?.islamicDoctorData?.length ? props?.islamicDoctorData[0] : null;
	const [openRequestInfoModal, setOpenRequestInfoModal] = useState(false);
	const headerImage = islamic_doctor_data?.ministry_header?.image?.url ?? islamic_doctor_data?.ministry_header?.image?.[0]?.url

	const closeModals = () => {
		setOpenRequestInfoModal(false);
	}

	return (
		<div className="degree-page">
			{openRequestInfoModal && <RequestInfoModal closeModals={closeModals} />}
			<>
				<div ref={el => elementRef.current["islamic-degree-sub-header"] = el} className="islamic-degree-sub-header w3-animate-zoom">
					<img src={`${process.env.CMS_API_ORIGIN}${headerImage}`} alt="Islamic Ministry" />
					<p>{islamic_doctor_data?.ministry_header?.title ?? null}</p>
				</div>
				<div className="container w3-animate-bottom" ref={el => elementRef.current["islamic-degree-sub-header-text"] = el}>
					<div className="row my-4">
						<div className="col-8">
							<h3>{islamic_doctor_data?.ministry_body?.heading ?? null}</h3>
							<p><div dangerouslySetInnerHTML={{__html:islamic_doctor_data?.ministry_body?.content ?? ''}}></div></p>
							{islamic_doctor_data?.ministry_requirements?.requirement_detail && <p><strong>Required:</strong> {islamic_doctor_data?.ministry_requirements?.requirement_detail}</p>}
							{islamic_doctor_data?.ministry_requirements?.substitution_detail && <p><strong>Substitution:</strong> {islamic_doctor_data?.ministry_requirements?.substitution_detail}</p>}
							{islamic_doctor_data?.ministry_accordion?.map(accordion => 
								<>
									{accordion?.heading && <p><strong>{accordion?.heading}</strong></p>}
									{accordion?.subHeading && <h5>{accordion?.subHeading}</h5>}
									<DoctorMinistryAccordion accordions={accordion?.ministry_accordions} />
									<br />
									<br />
								</>
							)}
						</div>
					</div>
				</div>
			</>
		</div>
	);
}

export default DoctorOfMinistry;